var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "18px",
    viewBox: "0 0 24 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "twitter-dark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kepler-home",
    transform: "translate(-1475.000000, -38.000000)",
    fill: "#E07D26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1498.70887,40.1305808 C1497.83681,40.4918923 1496.89889,40.7361954 1495.91486,40.8467748 C1496.91865,40.2835917 1497.69059,39.3938138 1498.05285,38.3330238 C1497.11229,38.8537753 1496.07294,39.2318023 1494.96377,39.4349596 C1494.07722,38.5516108 1492.81392,38 1491.41363,38 C1488.72764,38 1486.55014,40.0341453 1486.55014,42.5440389 C1486.55014,42.901493 1486.59361,43.2473748 1486.67528,43.5803986 C1482.63379,43.3913851 1479.0494,41.5809701 1476.65058,38.8319166 C1476.233,39.5031074 1475.99325,40.2835917 1475.99325,41.1167941 C1475.99325,42.6931924 1476.85213,44.0844346 1478.15626,44.8983499 C1477.35929,44.8752054 1476.60843,44.6707622 1475.95373,44.3300236 L1475.95373,44.3878848 C1475.95373,46.5891849 1477.62934,48.4253161 1479.85559,48.8432031 C1479.44722,48.9473534 1479.01778,49.002643 1478.57385,49.002643 C1478.26033,49.002643 1477.95603,48.9743553 1477.65964,48.9203515 C1478.27746,50.7256233 1480.07426,52.0397171 1482.20303,52.0770055 C1480.53795,53.2946639 1478.4408,54.0211444 1476.16055,54.0211444 C1475.76931,54.0211444 1475.3807,54.0005715 1475,53.9581399 C1477.15248,55.2478034 1479.70937,56 1482.45727,56 C1491.40309,56 1496.29556,49.075934 1496.29556,43.0712194 C1496.29556,42.8732052 1496.29029,42.6790485 1496.28239,42.483606 C1497.23217,41.8432745 1498.0568,41.0422173 1498.70887,40.1318666 L1498.70887,40.1305808 L1498.70887,40.1305808 Z",
    id: "twitter-dark"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterActive);
export default __webpack_public_path__ + "static/media/twitter_active.bdf89f9ccc38939114946a266f487b19.svg";
export { ForwardRef as ReactComponent };